export const IntegrationStatus = {
  CREATED: "created",
  AUTHORIZED: "authorized",
  UNAUTHORIZED: "unauthorized",
};
